import { HUNTERS_MARK_EFFECT_ID, huntersMarkDieSides, isMarkedByAttacker } from '../../../../shared/rules/ranger.mjs';

export { HUNTERS_MARK_EFFECT_ID, isMarkedByAttacker };
export const HUNTERS_MARK_FEATURE_ID = 'ranger:hunters-mark';

const ineligible = (reasonCode) => ({ status: 'ineligible', featureId: HUNTERS_MARK_FEATURE_ID, featureLabel: "Hunter's Mark", reasonCode });

// Hit contexts reach this hook only from attack rolls; these are the kinds the player producer sends.
const ATTACK_ROLL_KINDS = new Set(['weapon', 'unarmed', 'spell']);

/**
 * 2024 Hunter's Mark: every hit with an attack roll on the marked creature (weapon, Unarmed Strike or spell
 * attack) deals an extra 1d6 Force damage. 2014 limited it to weapon attacks.
 * It is not optional and not once per turn, so it applies automatically without a usage claim. Foe Slayer makes it a d10.
 */
export const evaluateHuntersMark = ({ context, queries = {} }) => {
  if (!ATTACK_ROLL_KINDS.has(context?.attack?.kind)) return ineligible('not-attack-roll');
  if (!isMarkedByAttacker(queries.activeEffects, context.attacker?.combatantId, context.target?.combatantId)) return ineligible('target-not-marked');
  return {
    status: 'automatic',
    featureId: HUNTERS_MARK_FEATURE_ID,
    featureLabel: "Hunter's Mark",
    reasonCode: 'marked-target',
    components: [{
      id: HUNTERS_MARK_FEATURE_ID,
      label: "Hunter's Mark",
      source: { type: 'spell', featureId: HUNTERS_MARK_FEATURE_ID },
      dice: { count: 1, sides: huntersMarkDieSides(context.attacker?.entity) },
      flat: 0,
      damageType: { mode: 'explicit', value: 'force' },
      critical: { dice: 'double' },
    }],
    claims: [],
  };
};
